module.exports = __webpack_public_path__ + "img/audit_refuse.47b81d7f.png";